import './PageTitle.css';

const PageTitle = () => {
  return(
    <div className='PageTitle'>
      <h1>Cestas Cooperflora Barão</h1>
    </div>
  )
};

export default PageTitle;